import React, { useEffect, useState } from "react";
import { Navbar, Nav } from "react-bootstrap";
import { useMediaQuery } from "react-responsive";
import { useHistory, withRouter } from "react-router-dom";
import logoDark from "../../../img/logo-dark.png";
import logoLight from "../../../img/logo-light.png";

import "./style.scss";

const Index = ({ white }) => {
  const [scrolled, setScrolled] = useState();

  const handleScroll = () => {
    if (window.pageYOffset > 0) {
      setScrolled(true);
    } else {
      setScrolled(false);
    }
  };

  useEffect(() => {
    document.addEventListener("scroll", handleScroll);
  });

  return (
    <header
      className={`public-navigation-container ${
        scrolled || white ? "white" : ""
      }`}
    >
      <div className="inner-public-header-container">
        <Navbar collapseOnSelect expand="md">
          <Navbar.Brand href="/">
            <img alt="Leadfind logo" className="header-logo" src={logoLight} />
          </Navbar.Brand>
          <Navbar.Toggle
            id="navBarToggle"
            aria-controls="responsive-navbar-nav"
          >
            <i class="fad fa-bars"></i>
          </Navbar.Toggle>
          <Navbar.Collapse className="collapse" id="responsive-navbar-nav">
            <Nav className="ml-auto links-container">
              <Nav.Link className="header-link" href="/">
                Forsiden
              </Nav.Link>
              <Nav.Link className="header-link" href="/blogg">
                Blogg
              </Nav.Link>
            </Nav>
            <Nav>
              <Nav.Link href="/logg-inn">
                <button className="login-button">Logg inn</button>
              </Nav.Link>
            </Nav>
          </Navbar.Collapse>
        </Navbar>
      </div>
    </header>
  );
};

export default Index;
